import React, { useState, useEffect } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import DataTable from 'react-data-table-component';
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar';
import { http } from '../helper';
import { capitalizeFirstLetter } from "../utilityfunctions";
import moment from 'moment';
import { canAction } from '../common/permissionhelper';
import Popup from '../common/popup';
import { useTranslation } from "react-i18next";

const Chefs = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [chefsList, setChefsList] = useState([]);
  const [tempList, setTempList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [selectedChef, setSelectedChef] = useState(null);
  const [showViewPopup, setShowViewPopup] = useState(false);
  const [selectedChefDetails, setSelectedChefDetails] = useState(null);

  useEffect(() => {
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/";
      return;
    }
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    if (
      authData &&
      !authData.adminRole.permissions.includes("manage_chefs")
    ) {
      window.location.href = "/unauthorized";
      return;
    }
    getChefsList();
  }, []);

  const getChefsList = () => {
    const URL = `${BaseUrl}admin/getchefs`;
    http
      .get(URL)
      .then((response) => {
        const responseData = response.data.data;
        setChefsList(responseData);
        setTempList(responseData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const editChefDetails = (editId) => {
    window.location.href = `/development-chef/edit/${editId}`;
  };

  const deleteChef = (chef) => {
    setVisibleAlert(true);
    setSelectedChef(chef);
  };

  const deleteChefDetails = () => {
    const URL = `${BaseUrl}admin/deletechefs/${selectedChef._id}`;
    http
      .delete(URL)
      .then((response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupClose = () => {
    setVisibleAlert(false);
    setSelectedChef(null);
  };

  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue.length > 0) {
      const result = tempList.filter((item) =>
        item.groupName?.toLowerCase().includes(lowercasedValue)
      );
      setChefsList(result);
    } else {
      setChefsList(tempList);
    }
  };

  const handleReset = () => {
    setSearchTextVal("");
    setChefsList(tempList);
  };

  const addChef = () => {
    window.location.href = "/development-chef/add";
  };

  const viewChefDetails = (chef) => {
    setShowViewPopup(true);
    setSelectedChefDetails(chef);
  };

  const closeViewPopup = () => {
    setShowViewPopup(false);
    setSelectedChefDetails(null);
  };

  const columns = [
    {
      name: t("group_name_txt"),
      selector: (row) => row.groupName,
      sortable: true,
    },
    {
      name: t("primary_account_txt"),
      selector: (row) =>
        row.primaryAccount
          ? `${row.primaryAccount.accountCode} - ${row.primaryAccount.accountName}`
          : "",
      sortable: true,
    },
    {
      name: t("status_txt"),
      selector: (row) => capitalizeFirstLetter(row.groupStatus),
      sortable: true,
    },
    {
      name: t("date_created_txt"),
      selector: (row) =>
        moment(row.createdAt).format("DD-MM-YYYY HH:mm A"),
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => {
        return (
          <div style={{ display: "flex" }}>
            {canAction("manage_chefs", "view") && (
              <a
                className="editbtn button title-tooltip title-up"
                data-title={t("view_txt")}
                style={{ color: "white" }}
                onClick={() => viewChefDetails(row)}
              >
                <i className="fa fa-eye" aria-hidden="true"></i>
              </a>
            )}
            {canAction("manage_chefs", "edit") && (
              <a
                className="editbtn button title-tooltip title-up"
                data-title={t("edit_txt")}
                style={{ color: "white" }}
                onClick={() => editChefDetails(row._id)}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i>
              </a>
            )}
            {canAction("manage_chefs", "delete") && (
              <a
                className="editbtn button title-tooltip title-up"
                data-title={t("delete_txt")}
                style={{ color: "white" }}
                onClick={() => deleteChef(row)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
            )}
          </div>
        );
      },
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("developement_chef_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_by_group_name")}
                      />
                    </div>
                    <button
                      className="submitbtn button"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_chefs", "add") && (
                    <div className="add-holidaybtn">
                      <button
                        className="addbtn"
                        onClick={addChef}
                      >
                        {t("add_txt")}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow dev-chef-data-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_data_in_chef_txt")}
                      </div>
                    }
                    data={chefsList}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("delete_confirmation_txt")}</p>
                <div className="alert-buttons">
                  <a
                    title={t("ok_txt")}
                    onClick={deleteChefDetails}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    title={t("cancel_txt")}
                    onClick={alertPopupClose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showViewPopup && selectedChefDetails && (
        <Popup
          extClass="order-pop info-poup"
          headMoreTxt={
            <div className="order-top">
              <div className="head">
                <h4>{t("chef_details_txt")}</h4>
              </div>
            </div>
          }
          bodyMoreTxt={
            <div className="order-top">
              <div className="bottom vendor-details vendor-table-view">
                <table className="vendor-table">
                    <tr>
                      <td>{t("group_name_txt")}</td>
                      <td>{selectedChefDetails.groupName || "-"}</td>
                    </tr>
                    <tr>
                      <td>{t("status_txt")}</td>
                      <td>
                        {capitalizeFirstLetter(
                          selectedChefDetails.groupStatus
                        ) || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("price_band_txt")}</td>
                      <td>
                        {selectedChefDetails.priceBand &&
                        selectedChefDetails.priceBand.length > 0
                          ? selectedChefDetails.priceBand.join(", ")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("primary_account_txt")}</td>
                      <td>
                        {selectedChefDetails.primaryAccount
                          ? selectedChefDetails.primaryAccount.accountCode
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("sub_account_txt")}</td>
                      <td>
                        {selectedChefDetails.accounts &&
                        selectedChefDetails.accounts.length > 0
                          ? selectedChefDetails.accounts
                              .map((acc) => acc.accountCode)
                              .join(", ")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("created_on_txt")}</td>
                      <td>
                        {moment(
                          selectedChefDetails.createdAt
                        ).format("DD-MM-YYYY HH:mm A")}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("updated_on_txt")}</td>
                      <td>
                        {moment(
                          selectedChefDetails.updatedAt
                        ).format("DD-MM-YYYY HH:mm A")}
                      </td>
                    </tr>
              
                </table>
              </div>
            </div>
          }
          closebtn={
            <span
              onClick={closeViewPopup}
              className="close"
            ></span>
          }
        />
      )}
    </>
  );
};

export default Chefs;